<!-- Top bar -->
<mat-toolbar class="topBar">

    <!-- Back to Home -->
    <button mat-icon-button
            class="example-icon"
            type="button"
            aria-label="Example icon-button with menu icon"
            matTooltip="Back to Home"
            matTooltipPosition="below"
            (click)="router.navigate(['menu'])">
      <mat-icon>
        arrow_back
      </mat-icon>
    </button>
  
    <span>Drafts for {{user.userName}}</span>
  </mat-toolbar>
  
  @for (draft of drafts; track draft.localLandingGUID; let index = $index) {
      <div style="padding-left: 10px; padding-right: 10px; padding-top: 10px; font-size: 16px;">
          <mat-card matRipple (click)="onDraftClick(index)" style="padding: 16px">
              <div class="container" style="padding-left: 12px; padding-right: 12px;">
                  <div class="row">
                      <div class="col-3">
                          <b>Trip Draft</b>
                      </div>
                      <div class="col-9">
                          <b>Trip departure: </b>{{draft.departureDate | date:'EE, MMM.dd'}}                       
                          <br>
                          <b>Trip return: </b>{{draft.arrivalDate | date:'EE, MMM.dd'}}                      
                      </div>
                  </div>
              </div>
          </mat-card>
      </div>
      
  }
  